import React from 'react';
import { Chip } from '../../../../../../../../components/Chip';
import { ListCandidateApplication } from '../../../../../../../../entities/applicant_tracking/ListCandidate';
import { jobStageChipColor } from '../../../../../../../../utils/jobStageChipColor';
import { getDurationInMaxUnit } from '../../../../../../../../utils/duration';

interface PropTypes {
  application?: ListCandidateApplication;
}

export function Stages(props: PropTypes) {
  if (props.application == null || props.application.currentStage.name == null)
    return (
      <div className='d-flex justify-content-center'>
        <span>-</span>
      </div>
    );

  const stageName = props.application.currentStage.name;
  const timeInStage = getDurationInMaxUnit(
    props.application.currentStage.millisInStage,
    ['minutes', 'hours', 'days', 'months'],
  );

  return (
    <div className='d-flex align-items-center'>
      <Chip
        className={'py-1 px-2h fs-6 fw-semibold'}
        color={jobStageChipColor(stageName)}
      >
        {stageName}
      </Chip>
      <small className='text-muted text-truncate ms-2'>
        {timeInStage.value != null &&
          `${timeInStage.value} ${timeInStage.unit}`}
      </small>
    </div>
  );
}
